<template>
    <div class="wrapper padding-sm bg-white">
        <div class=" flex justify-between align-center margin-bottom-sm">
            <div class="page-title">邮件群发 <span>用邮件通知会员 高效精准阅读率更高</span></div>
            <el-button class="blue-btn" round @click="$router.go(-1)">返回</el-button>
        </div>
        <div class=" flex justify-between align-center margin-bottom-sm">
            <div class="page-title-two">系统会员/分支机构</div>
            <el-button class="blue-btn" round type="primary" @click="chioseDialog = true">
                {{
                    members.length === 0 && membersFh.length === 0 ? "会员/分支机构选择" : "已选择" +
                        (members.length + membersFh.length) + "家会员/分支机构"
                }}
            </el-button>
        </div>
        <div v-if="membersList.length>0 || membersListFh.length>0" class="member-list-box">
            <el-row :gutter="10">
                <el-col v-for="item in membersList" :key="item.user_id" :span="8">
                    <div class="member-item">
                        <div class="ovHide">机构：{{ item.company }}</div>
                        <div>邮箱：{{ item.email }}</div>
                    </div>
                </el-col>
                <el-col v-for="item in membersListFh" :key="item.id" :span="8">
                    <div class="member-item">
                        <div class="ovHide">机构：{{ item.name }}</div>
                        <div>邮箱：{{ item.email }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class=" flex justify-between align-center margin-bottom-sm">
            <div class="page-title-two">外部联系人</div>
            <div class="flex align-center">
                <el-button class="blue-btn" round style="width: 143px" type="primary" @click="otherDialog = true">
                    联系人添加
                </el-button>
                <el-upload
                    :action="`${baseURL}admin/Sendemail/parsingExcelEmail`"
                    :data="fileData"
                    :name="'file'"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    class="margin-left-xs">
                    <el-button class="blue-btn" round style="width: 143px" type="primary">联系人导入</el-button>
                </el-upload>

                <a class="margin-left-xs" target="_blank" :href="`${IMAGE_PATH}upload/excelphone/email_demo.xls`">
                    <el-button class="blue-btn" round style="width: 143px" type="primary">下载模版</el-button>
                </a>
            </div>
        </div>
        <div v-if="othermembersList.length>0" class="member-list-box">
            <el-row :gutter="10">
                <el-col v-for="(item,index) in othermembersList" :key="index" :span="8">
                    <div class="member-item">
                        <div class="ovHide">机构：{{ item.name }}</div>
                        <div class="flex align-center justify-between">邮箱：{{ item.email }}
                            <el-link type="danger" @click="otherDel(index)"><i class="el-icon-delete"></i></el-link>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="sms-container flex flex-direction">
            <div class="flex align-center">
               <div class="margin-right-xs"> 发件人：</div>
                <el-select class="flex-sub" v-model="email_id" placeholder="请选择发送邮箱">
                    <el-option
                        v-for="item in email_list"
                        :key="item.id"
                        :label="`${item.email}`"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <el-input class="margin-tb-xs" v-model="title" placeholder="请输入标题"></el-input>
            <VueUditorWrap class="margin-bottom-sm" v-model="message" :config="myConfig"></VueUditorWrap>
            <el-button class="self-end" type="primary" @click="sendMessage" :loading="loading">发送邮件</el-button>
        </div>
        <chiose-dialog
            :chioseDialog="chioseDialog"
            @cancelChiose="cancelChiose"
            @saveChiose="saveChiose"/>
        <add-other-member-dialog
            :apply-dialog-visible="otherDialog"
            @saveOther="saveOther"
            @watchState="watchState"/>
    </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {checkEmailfield, getEmailList, sendEmail} from "@/api/organiz";
import ChioseDialog from "./ChioseDialog";
import AddOtherMemberDialog from "./AddOtherMemberDialog";
import {baseURL, IMAGE_PATH} from "@/config";
import {bdEditConfig} from "@/utils/utils";

export default {
    name: "send",
    data() {
        return {
            myConfig: bdEditConfig(),
            baseURL:baseURL,
            IMAGE_PATH:IMAGE_PATH,
            email_id: '',
            title: '',
            message: '',

            loading: false,
            chioseDialog: false,
            email_list: [],
            members: [],
            membersList: [],
            membersFh: [],
            membersListFh: [],
            otherDialog: false,
            othermembersList: [],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                mid: this.$store.state.user.mid
            }
        }
    },
    created() {
        this.$emit('setIndex', [1, 3], '邮件群发')
        this.init()
    },
    components: {
        ChioseDialog,
        VueUditorWrap,
        AddOtherMemberDialog
    },
    methods: {
        async init(){
            let _data = await getEmailList(1,1000)
            this.email_list = _data.data
            if (_data.data.length){
                this.email_id = _data.data[0].id
            }
            _data = await checkEmailfield()
            if (_data.status === 400){
                this.$confirm(_data.msg, '温馨提示', {
                    confirmButtonText: '去设置',
                    cancelButtonText: '取消',
                    center: true
                }).then(() => {
                    this.$router.push('/organization/setup/information')
                })
            }
        },
        async sendMessage() {
            if (this.membersList.length === 0 && this.membersListFh.length === 0 && this.othermembersList.length === 0) return this.$message.error('请选择系统会员/分支机构或填写外部联系人')
            let _arr = []
            this.membersList.map(item => {
                _arr.push({name: item.company, email: item.email})
            })
            this.membersListFh.map(item => {
                _arr.push({name: item.name, email: item.email})
            })
            this.othermembersList.map(item => {
                _arr.push({name: item.name, email: item.email})
            })
            if (!this.title) return  this.$message.error('请输入标题')
            if (!this.message) return  this.$message.error('请输入内容')
            let _email = this.email_list.find(f=>{return f.id === this.email_id})
            this.loading = true
            let _state = await sendEmail(
                _email.email, _email.code,this.title,this.message,
                JSON.stringify(_arr),
            )
            this.loading = false
            this.$message.success(_state.msg)
            this.$router.go(-1)
        },
        //  删除外部联系人
        otherDel(index) {
            this.$confirm('此操作将删除该联系人, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                center: true
            }).then(() => {
                this.othermembersList.splice(index, 1)
            })
        },
        //  保存外部联系人
        saveOther(val) {
            this.othermembersList.push(JSON.parse(JSON.stringify(val)))
            this.watchState()
        },
        //  关闭外部联系人
        watchState() {
            this.otherDialog = false
        },
        //  标签选择保存发送人员
        saveChiose(val) {
            this.chioseType = val[0]
            this.members = val[1]
            this.membersList = val[2]
            this.membersFh = val[3]
            this.membersListFh = val[4]
            this.cancelChiose()
        },
        //  关闭弹框
        cancelChiose() {
            this.chioseDialog = false
        },
        handleAvatarSuccess(res) {
            if (res.status === 200) {
                res.data.map(item=>{
                    item.company = item.name
                })
                this.othermembersList = [...this.othermembersList,...res.data]
            } else {
                this.$message.error(res.msg)
            }
        },
    },
    filters: {},
    watch: {

    },
}
</script>

<style lang="scss" scoped>
.wrapper {
    .page-title {
        span {
            font-size: 16px;
            line-height: 45px;
            color: #999999;
            font-weight: normal;
        }
    }

    .page-title-two {
        width: 60%;

        span {
            font-size: 16px;
            line-height: 45px;
            color: #999999;
            font-weight: normal;
        }

        i {
            display: inline-block;
            width: 140px;
            height: 18px;
            text-align: center;
            line-height: 18px;
            font-size: 14px;
            background-image: linear-gradient(37deg,
                #ffb400 0%,
                #fc7802 100%),
            linear-gradient(
                    #0a2240,
                    #0a2240);
            background-blend-mode: normal,
            normal;
            border-radius: 9px;
            color: #fff;
        }
    }

    .page-tip {
        span {
            color: #ffb400;
        }
    }

    .member-list-box {
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;

        .member-item {
            background: rgba(#fff, .4);
            border: 1px dashed #ffb400;
            border-radius: 4px;
            padding: 5px 10px;
            margin-bottom: 10px;
            font-size: 14px;
            line-height: 20px;
            color: #0a2240;
        }
    }

    .self-end {
        display: block;
        width: 200px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        padding: 0;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#0a2240, #0a2240);
        background-blend-mode: normal, normal;
        border-radius: 20px;
        font-size: 16px;
        color: #fff;
    }
}
</style>